import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {

  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  
  // getProfiles(
  //   pageSize: number = 10,
  //   pageIndex: number = 0,
  //   sortDirection: string = 'asc',
  //   sortProperty: string = 'nome',
  //   codigo: string = '',
  //   name: string = '',
  //   statusFilter: string = ''
  // ) {
  //   return this.http.get(
  //     this.baseUrl +
  //     `/v1/user-profiles?size=${pageSize}page=${pageIndex}&sortField=${sortProperty}&sortDirection=${sortDirection}&codigo=${codigo}&nome=${name}&status=${statusFilter}`
  //   );
  // }
  getProfiles(
    pageSize: number = 10,
    pageIndex: number = 0,
    sortDirection: string = 'asc',
    sortProperty: string = 'nome',
    codigo: string = '',
    name: string = '',
    statusFilter: string = ''
  ) {
    return this.http.get(
      this.baseUrl +
      `/v1/user-profiles?page=${pageIndex}&sortField=${sortProperty}&sortDirection=${sortDirection}&codigo=${codigo}&nome=${name}&status=${statusFilter}`
    );
  }

  getProfile(id: string) {
    return this.http.get(this.baseUrl + `/v1/user-profiles/${id}`);
  }

  createProfile(profileData: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(this.baseUrl + '/v1/user-profiles', profileData, {
      headers,
    });
  }

  editProfile(id: string | null, profileData: any) {
    return this.http.patch(this.baseUrl + `/v1/user-profiles/${id}`, profileData);
  }

  deleteProfile(id: string) {
    return this.http.delete(this.baseUrl + `/v1/user-profiles/${id}`);
  }

  activate(id: number) {
    return this.http.patch(this.baseUrl + `/v1/user-profiles/${id}/active`, {});
  }

  inactivate(id: number) {
    return this.http.patch(this.baseUrl + `/v1/user-profiles/${id}/inactive`, {});
  }
}
